import { getLocale } from "../runtime";

const sv_productusp3 = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Nöjd kund-garanti`
};

const productusp3 = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_productusp3(inputs)
	return "productUsp3";
};

export { productusp3 as "productUsp3" };